export class AppError extends Error {
  public userMessage: string;

  constructor(userMessage: string, message: string) {
    super(message);
    this.userMessage = userMessage;
  }
}
